import React, { memo, useCallback, useRef } from 'react';
import AlertDialog from '../../Dialog/Dialog';
import { useLang } from '../../../util/lang';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, setIsOpen } from '../../../store/ErrorMessage/ErrorMessageSlice';

const ErrorDialog = () => {
    const get = useLang();
    const { dialogTitle, dialogMessage, isOpen, dialogFunction } = useSelector((state) => state.errorMessage); //Reminder: ignore the error: does not exist in DefaultRoot if log the destructure state successfully
    const dispatch = useDispatch();
    const lastTitleRef = useRef(':const.warning');

    // Keep track of the last non-empty title so it doesn't flash "Warning" during close animation
    if (isOpen && dialogTitle) {
        lastTitleRef.current = dialogTitle;
    }

    const handleDialogClose = useCallback(() => {
        dispatch(closeDialog());
        dialogFunction();
    }, [dialogFunction]);

    const titleKey = dialogTitle || (isOpen ? ':const.warning' : lastTitleRef.current);

    return (
        <AlertDialog
            title={get(titleKey)}
            dialogOpen={isOpen}
            handleDialogClose={handleDialogClose}
            content={get(dialogMessage)}
        />
    );
};

export default memo(ErrorDialog);
